import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Redondea un valor de <input type="datetime-local"> ("YYYY-MM-DDTHH:mm") al cuarto de hora
// más cercano (00, 15, 30, 45). Necesario porque el atributo `step` del input no restringe
// el desplegable nativo de minutos en todos los navegadores.
export function roundToQuarterHour(value) {
  if (!value) return value;
  const [datePart, timePart] = value.split("T");
  if (!timePart) return value;
  let [h, m] = timePart.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return value;
  m = Math.round(m / 15) * 15;
  if (m === 60) { m = 0; h = (h + 1) % 24; }
  const pad = (n) => String(n).padStart(2, "0");
  return `${datePart}T${pad(h)}:${pad(m)}`;
}

